/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { a as Spinner, d as defineCustomElement$1 } from './spinner.js';

const IonSpinner = Spinner;
const defineCustomElement = defineCustomElement$1;

export { IonSpinner, defineCustomElement };
